import { FunctionalComponent, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import BackgroundBanner from "../../../components/BackgroundBanner";
import {
  get_AI_URI_BASE,
  get_DASHBOARD_URI_BASE,
  getIsEdge,
} from "../../../configs/env";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import CategoryFilters from "../../../components/saerchResults/CategoryFilters";
import {
  setCategories,
  setDocsFilterStatus,
  setExactMatch,
  setInitialKeywordsDocuments,
  setKapps,
  setLastExactMatch,
  setNestedTags,
  setSelectedCategory,
  setSelectedFilters,
  setSelectedNestedTags,
  setTags,
  setTypedYearFrom,
  setTypedYearTo,
  setYearFilterStatus,
} from "../../../redux/slices/searchSlice";
import { initialSelectedFilters } from "../../../models/consts";
import {
  SelectedFilters,
  SelectedItem,
  Tag,
  TreeNode,
} from "../../../models/interfaces";
import axios from "axios";
// import EmptyStateIcon from "../../../assets/icons/EmptyStateIcon";
import styles from "./styles.css";
import { convertJson, getSassToken, getSelectedNames } from "../../../utils";
import logger from "../../../logger";
// import { getEdgeUserLoginSession } from "../../../utils";
import {
  getInitialDocuments,
  getSourceElement,
} from "../../../routes/search/getCall";
import DocumentsTable from "../../../components/home/KeywordDocuments";
import { useRef } from "react";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import { setIsViewIframe } from "../../../redux/slices/appearanceSlice";
import DocumentViewer from "../../../components/DocumentViewer";
import Spinner from "../../../routes/search/spinner";
interface Props {
  workspaceId?: string;
  portalId?: string;
  workspaceAlias?: string;
  portalAlias?: string;
  mode?: string;
  isPaying: boolean;
  isIframe?: boolean;
}
const KeywordLayout: FunctionalComponent<Props> = (props) => {
  const {
    workspaceId,
    portalId,
    workspaceAlias,
    portalAlias,
    mode,
    isPaying,
    isIframe,
  } = props;
  const alias = useAppSelector((state) => state.alias);
  const appearance = useAppSelector((state) => state.appearance);
  const search = useAppSelector((state) => state.search);
  const dispatch = useAppDispatch();
  const [sasToken, setSasToken] = useState<string | undefined>(undefined);
  const [updatedNestedTags, setUpdateNestedTags] = useState<TreeNode>();
  const playerWrapper = useRef<HTMLDivElement>(null);
  const isFullScreen = useRef(false);
  const isExpandScreen = useRef(false);
  const isInnerFullScreen = useRef<HTMLDivElement>(null);
  const topWrapper = useRef<HTMLDivElement>(null);
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const closeContainerRef = useRef<HTMLDivElement>(null);
  const isMobileOnly = appearance.narrowfactor || isMobileOnlyReact;
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const globals = useAppSelector((state) => state.globals);
  const [docDetail, setDocDetail] = useState({
    type: "",
    kapp: "",
    docGuid: "",
    guid: "",
    page: "",
  });
  useEffect(() => {
    if (docDetail?.type === "pdf" && docDetail?.docGuid) {
      const fetchSasToken = async () => {
        try {
          const token = await getSassToken(
            workspaceId || alias.workspaceId,
            portalId || alias.portalId || "",
            globals.userId || null,
            globals.jwtUserIdToken || null,
            getIsEdge()
          );
          setSasToken(token);
        } catch (error) {
          console.error("Failed to fetch SAS token:", error);
          setSasToken(undefined);
        }
      };

      fetchSasToken();
      const interval = setInterval(fetchSasToken, 3 * 60 * 1000);

      return () => clearInterval(interval);
    } else {
      setSasToken(undefined);
    }
  }, [
    docDetail,
    workspaceId,
    alias.workspaceId,
    portalId,
    alias.portalId,
    globals.userId,
    globals.jwtUserIdToken,
  ]);
  const handleToggleEpandScreen = () => {
    if (window.innerWidth > 1000) {
      isExpandScreen.current = !isExpandScreen.current;
      if (isExpandScreen.current && playerWrapper.current) {
        playerWrapper.current.style.display = "none";
      } else if (!isExpandScreen.current && playerWrapper.current) {
        playerWrapper.current.style.display = "block";
      }
    }
  };
  useEffect(() => {
    document.title = appearance.experienceName;
  }, [appearance.experienceName, isDrawerOpen]);
  const handleToggleFullScreen = () => {
    isFullScreen.current = !isFullScreen.current;

    if (isFullScreen.current) {
      if (
        isMobileOnlyReact &&
        videoContainerRef.current &&
        closeContainerRef.current
      ) {
        const container = videoContainerRef.current;
        closeContainerRef.current.style.transform = "rotate(90deg)";
        closeContainerRef.current.style.bottom = "8%";
        container.style.transform = "rotate(90deg)";
        container.style.transformOrigin = "bottom left";
        container.style.position = "absolute";
        container.style.top = "-100vw";
        container.style.left = "0";
        container.style.height = "100vw";
        container.style.width = "100vh";
        container.style.backgroundColor = "#000";
        container.style.color = "#fff";
        container.style.overflow = "auto";
      }
      if (
        // articleDetails?.show &&
        isDrawerOpen &&
        playerWrapper.current &&
        isInnerFullScreen.current &&
        topWrapper.current
      ) {
        playerWrapper.current.style.width = "0%";
        isInnerFullScreen.current.style.display = "none";
      }
      if (
        // !articleDetails?.show &&
        isDrawerOpen &&
        playerWrapper.current &&
        isInnerFullScreen.current &&
        topWrapper.current
      ) {
        playerWrapper.current.style.width = "0%";
        isInnerFullScreen.current.style.display = "none";
      }
    } else {
      if (
        isMobileOnlyReact &&
        videoContainerRef.current &&
        closeContainerRef.current
      ) {
        const container = videoContainerRef.current;
        closeContainerRef.current.style.transform = "rotate(0deg)";
        closeContainerRef.current.style.bottom = "";
        container.style.transform = "rotate(0deg)";
        container.style.transformOrigin = "";
        container.style.position = "";
        container.style.top = "0";
        container.style.left = "0";
        container.style.height = "96%";
        container.style.width = "100%";
        container.style.backgroundColor = "#000";
        container.style.color = "#fff";
        container.style.overflow = "auto";
      }
      if (
        playerWrapper.current &&
        // articleDetails?.show &&
        isDrawerOpen &&
        isInnerFullScreen.current &&
        topWrapper.current
      ) {
        playerWrapper.current.style.width = "90%";
        isInnerFullScreen.current.style.display = "block";
      }
      if (
        playerWrapper.current &&
        // !articleDetails?.show &&
        isDrawerOpen &&
        isInnerFullScreen.current &&
        topWrapper.current
      ) {
        playerWrapper.current.style.width = "100%";
        isInnerFullScreen.current.style.display = "block";
      }
    }
  };
  useEffect(() => {
    if (!isDrawerOpen && playerWrapper.current && isInnerFullScreen.current) {
      playerWrapper.current.style.width = "100%";
      isInnerFullScreen.current.style.display = "block";
    }
  }, [isDrawerOpen]);
  const handleNestedTagChange = (data: any) => {
    setUpdateNestedTags(data);
    const nestedTagArray = getSelectedNames(data.children);
    if (nestedTagArray) {
      dispatch(setSelectedNestedTags(nestedTagArray));
    }
  };
  useEffect(() => {
    if (alias.workspaceId && alias.portalId) {
      setFilters();
    }
  }, [alias.workspaceId, alias.portalId]);
  const setFilters = async (_portalId?: string) => {
    try {
      let _kapps = [];
      if (_portalId || portalId || alias.portalId) {
        try {
          if (search.kapps.length == 0) {
            const kappsResponse = await axios(
              `${get_DASHBOARD_URI_BASE()}/flow/kapps/portals/${
                _portalId || portalId || alias.portalId
              }`
            );
            if (kappsResponse?.data?.data?.length > 0) {
              _kapps = kappsResponse.data.data.map((kapp: any) => {
                kapp.selected = false;
                return kapp;
              });
              // get tags
              if (appearance.filtersType === "tags") {
                const tagsResponse = await axios(
                  `${get_DASHBOARD_URI_BASE()}/flow/tags/workspace/${
                    workspaceId || alias.workspaceId
                  }/kapps/${JSON.stringify(_kapps.map((kapp: any) => kapp.id))}`
                );
                if (tagsResponse?.data?.data?.length > 0) {
                  dispatch(setTags(tagsResponse.data.data));
                }
              }
              if (appearance.filtersType === "category") {
                const categoryResponse = await axios(
                  `${get_DASHBOARD_URI_BASE()}/flow/tags/category/workspace/${
                    workspaceId || alias.workspaceId
                  }/kapps/${JSON.stringify(_kapps.map((kapp: any) => kapp.id))}`
                );
                if (categoryResponse?.data?.data) {
                  dispatch(setCategories(categoryResponse?.data?.data));
                }
              }
            }
          } else {
            _kapps = JSON.parse(JSON.stringify(search.kapps)).map(
              (kapp: any) => {
                if (!kapp.selected) {
                  kapp.selected = false;
                }
                return kapp;
              }
            );
          }
        } catch (error: any) {
          // use descriptive error message
          logger.error({
            message: "Failed to fetch kapps or filters data",
            error: error?.message,
            stacktrace: error?.stack,
            workspace_id: workspaceId || alias.workspaceId,
            portal_id: _portalId || portalId || alias.portalId,
            filters_type: appearance.filtersType,
          });
        }
      }
      dispatch(setKapps(_kapps));
    } catch (error) {
      logger.error({
        message: "Error in setFilters function",
        error: error,
        workspace_id: workspaceId || alias.workspaceId,
        portal_id: portalId || alias.portalId,
      });
    }
  };
  useEffect(() => {
    document.title = appearance.experienceName;
  }, [appearance.experienceName]);
  const handleClearNestedTags = async () => {
    const nestedTagesResponse = await axios(
      `${get_AI_URI_BASE()}/doc-tagger/get_tag_trees/workspace_id/${
        workspaceId || alias.workspaceId
      }/kapps/${search?.kapps?.map((kapp) => kapp.id).join(",")}`
    );
    if (nestedTagesResponse?.data) {
      // Convert JSON data to the hierarchical structure
      const convertedData: TreeNode[] = Object.entries(
        nestedTagesResponse?.data
      ).map(([key, value]: any) => convertJson(value, key));
      let data = {
        children: convertedData,
      };
      dispatch(setNestedTags(data));
    }
  };
  const clearAllFilters = () => {
    dispatch(setSelectedFilters(initialSelectedFilters));
    dispatch(setLastExactMatch(search.exactMatch));
    dispatch(setExactMatch(""));
    dispatch(setTypedYearFrom(""));
    dispatch(setTypedYearTo(""));
    if (search.selectedNestedTags?.length > 0) {
      handleClearNestedTags();
    }
    dispatch(setYearFilterStatus(false));
    dispatch(setDocsFilterStatus(false));
    dispatch(
      setKapps(
        JSON.parse(JSON.stringify(search.kapps)).map((kapp: any) => {
          kapp.selected = false;
          return kapp;
        })
      )
    );
    let newTags = JSON.parse(JSON.stringify(search.tags));
    newTags = newTags.map((t: Tag) => {
      t.selected = false;
      return t;
    });
    dispatch(setTags(newTags));
  };
  const filterTagsForUI = (tag: Tag) => {
    // if all kapps selected, show all tags
    if (isAllTopics()) {
      return true;
    }
    // if kapp selected, show tags for that kapp
    if (
      search.kapps.find((kapp: any) => kapp.selected && kapp.id === tag.kappId)
    ) {
      return true;
    }
    return false;
  };
  const isAllTopics = () => {
    return (
      search.kapps.every((kapp: any) => kapp.selected) ||
      search.kapps.every((kapp: any) => !kapp.selected)
    );
  };
  const tagClicked = (tag: Tag) => {
    let newTags = JSON.parse(JSON.stringify(search.tags));
    newTags = newTags.map((t: Tag) => {
      if (t.value === tag.value) {
        t.selected = !t.selected;
      }
      return t;
    });
    dispatch(setTags(newTags));
    let newQueryParamsFilters: SelectedFilters = JSON.parse(
      JSON.stringify(search.selectedFilters)
    );
    newQueryParamsFilters.selectedTags = (
      newTags
        ?.filter((t: Tag) => t.selected)
        ?.map((t: Tag) => t.value) as string[]
    )?.filter((value: string, index: number, self: string[]) => {
      if (self.slice(0, index).indexOf(value) === -1) {
        return true;
      }
      return false;
    });
    dispatch(setSelectedFilters(newQueryParamsFilters));
  };
  const removeTag = (item: any) => {
    if (item.isKapp) {
      let kapp = search.kapps.find((k) => item.name === k.name);
      if (kapp) {
        filtersToggleKappSelection(kapp);
      }
    } else {
      let tag = search.tags.find((t) => item.name === t.value);
      if (tag) {
        tagClicked(tag);
      }
    }
    // console.log("item", item);
  };
  const filtersToggleKappSelection = (kapp: any) => {
    let newQueryParamsFilters: SelectedFilters = JSON.parse(
      JSON.stringify(search.selectedFilters)
    );
    if (!kapp.selected) {
      newQueryParamsFilters.selectedKapps.push(kapp.id);
    } else {
      const index = newQueryParamsFilters.selectedKapps.findIndex(
        (selectedKappId) => kapp.id === selectedKappId
      );
      if (index > -1) {
        newQueryParamsFilters.selectedKapps.splice(index, 1);
      } else {
        logger.error({
          message: "Failed to find kapp index in selectedKapps array",
          kapp_id: kapp.id,
          selected_kapps: newQueryParamsFilters.selectedKapps,
          workspace_id: workspaceId || alias.workspaceId,
          portal_id: portalId || alias.portalId,
        });
      }
    }

    let updatedKapps: any[] = JSON.parse(JSON.stringify(search.kapps)).map(
      (k: any) => {
        if (k.id === kapp.id) {
          if (k?.selected) {
            k.selected = false;
          } else {
            k.selected = true;
          }
          return k;
        } else {
          return k;
        }
      }
    );
    if (updatedKapps.every((kapp: any) => kapp.selected)) {
      updatedKapps = updatedKapps.map((kapp: any) => {
        kapp.selected = false;
        return kapp;
      });
      newQueryParamsFilters.selectedKapps = [];
    }
    dispatch(setSelectedFilters(newQueryParamsFilters));
    dispatch(setKapps(updatedKapps));
  };
  const selectAllTopics = () => {
    let newQueryParamsFilters: SelectedFilters = JSON.parse(
      JSON.stringify(search.selectedFilters)
    );
    newQueryParamsFilters.selectedKapps = [];
    dispatch(setSelectedFilters(newQueryParamsFilters));
    dispatch(
      setKapps(
        JSON.parse(JSON.stringify(search.kapps)).map((kapp: any) => {
          kapp.selected = false;
          return kapp;
        })
      )
    );
  };
  const handleCheckboxChange = (
    arrayName: string,
    nestedKey: string,
    nestedValue: unknown
  ) => {
    const WafersArrayName = "wafer_size";
    const wafers_200 = ["200mm", "200 mm"];
    const wafers_300 = ["300mm", "300 mm", "299-301mm"];
    const wafers_200_300 = ["200mm and 300mm", "200 mm/300 mm"];
    // setLoading(true);
    const newSelection: SelectedItem = { arrayName, nestedKey, nestedValue };

    // Toggle the selection state
    const isSelected = search?.selectedCategory.some(
      (item) => item.nestedKey === nestedKey && item.nestedValue === nestedValue
    );

    if (arrayName === WafersArrayName) {
      let selections: SelectedItem[] = [];
      const mm200isSelected = search?.selectedCategory.some(
        (item) => item.nestedKey === "200mm"
      );
      const mm300isSelected = search?.selectedCategory.some(
        (item) => item.nestedKey === "300mm"
      );

      if (isSelected) {
        // If already selected, remove it

        if (nestedKey === "200mm") {
          if (mm300isSelected) {
            selections = search?.selectedCategory?.filter(
              (item: any) => !wafers_200.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          } else {
            selections = search?.selectedCategory?.filter(
              (item: any) =>
                !wafers_200.includes(item.nestedKey) &&
                !wafers_200_300.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          }
        } else {
          if (mm200isSelected) {
            selections = search?.selectedCategory?.filter(
              (item: any) => !wafers_300.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          } else {
            selections = search?.selectedCategory?.filter(
              (item: any) =>
                !wafers_300.includes(item.nestedKey) &&
                !wafers_200_300.includes(item.nestedKey)
            );
            dispatch(setSelectedCategory(selections || []));
          }
        }
        return;
      } else {
        let tempMixArray: string[] = [];
        // If not selected, add it
        if (nestedKey === "200mm") {
          if (mm300isSelected) {
            const selections_200 = wafers_200.map((value) => ({
              arrayName: WafersArrayName,
              nestedKey: value,
              nestedValue: nestedValue,
            }));
            selections = [...selections_200];
          } else {
            tempMixArray = [...wafers_200, ...wafers_200_300];
            const selections_200and300 = tempMixArray.map((value) => ({
              arrayName: WafersArrayName,
              nestedKey: value,
              nestedValue: nestedValue,
            }));
            selections = [...selections_200and300];
          }
        } else {
          let tempMixArray: string[] = [];
          if (mm200isSelected) {
            const selections_300 = wafers_300.map((value) => ({
              arrayName: WafersArrayName,
              nestedKey: value,
              nestedValue: nestedValue,
            }));
            selections = [...selections_300];
          } else {
            tempMixArray = [...wafers_300, ...wafers_200_300];
            const selections_200and300: SelectedItem[] = tempMixArray.map(
              (value) => ({
                arrayName: WafersArrayName,
                nestedKey: value,
                nestedValue: nestedValue,
              })
            );
            selections = [...selections_200and300];
          }
        }
        dispatch(
          setSelectedCategory([...search?.selectedCategory, ...selections])
        );
      }
      return;
    }

    let tempArray: any = [];
    if (isSelected) {
      // If already selected, remove it

      const newTemp = search?.selectedCategory?.filter(
        (item: any) =>
          item.nestedKey !== nestedKey || item.nestedValue !== nestedValue
      );
      tempArray = [...newTemp];
      dispatch(setSelectedCategory(newTemp));
    } else {
      // If not selected, add it
      tempArray = [...search?.selectedCategory, newSelection];
      dispatch(setSelectedCategory(tempArray));
    }
  };
  const clearCategoryFilters = () => {
    dispatch(setSelectedCategory([]));
  };
  const getSelectedItems = () => {
    const selectedKapps = search.kapps.filter((kapp) => kapp.selected);
    const selectedTags = search.tags.filter((tag) => tag.selected);

    const selectedItems = [
      ...selectedKapps.map((kapp) => ({ name: kapp.name, isKapp: true })),
      ...selectedTags.map((tag) => ({ name: tag.value })),
    ];

    return selectedItems;
  };

  const selectedItems = getSelectedItems();
  const handleUpdateNestedTags = () => {
    dispatch(setNestedTags(updatedNestedTags));
  };

  useEffect(() => {
    if (isIframe) {
      dispatch(setIsViewIframe(isIframe ? true : false));
    }
  }, [isIframe]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    const requestUrl = `${get_AI_URI_BASE()}/ai/client/document_search?company_id=${
      alias.workspaceId
    }&portal_id=${alias.portalId}&workspace_alias=${
      alias.workspaceAlias
    }&portal_alias=${alias.portalAlias}&num_scores=10&session_id=${
      globals.sessionId
    }&page=${currentPage}`;

    const response = await getInitialDocuments(requestUrl, {});
    // console.log("Initial documents response:", response);

    let sources: any[] = [];

    for (let i = 0; i < response.results.length; i++) {
      const result = response.results[i];

      const srcElementResult = getSourceElement(
        result,
        alias,
        result?.search?._source?.action?.name,
        appearance.highlightPdf
      );

      sources.push(srcElementResult);
    }
    dispatch(
      setInitialKeywordsDocuments({
        pages: response.pages,
        source: sources,
      })
    );
    setLoading(false);
    // console.log("Initial documents sources:", sources);
  };
  useEffect(() => {
    if (alias.workspaceId && alias.portalId && globals.sessionId) {
      fetchData();
    }
  }, [alias.workspaceId, alias.portalId, globals.sessionId, currentPage]);
  return (
    <div style={{ display: "flex" }} ref={topWrapper}>
      <DocumentViewer
        isDrawerOpen={isDrawerOpen}
        docDetail={docDetail}
        setDrawerOpen={setDrawerOpen}
        handleToggleFullScreen={handleToggleFullScreen}
        handleToggleEpandScreen={handleToggleEpandScreen}
        videoContainerRef={videoContainerRef}
        closeContainerRef={closeContainerRef}
        sasToken={sasToken}
      />
      <div
        ref={playerWrapper}
        style={{
          display:
            (window.innerWidth < 1000 || isIframe) && isDrawerOpen
              ? "none"
              : "block",
          width:
            (window.innerWidth < 1000 || isIframe) && isDrawerOpen
              ? "0%"
              : // : articleDetails?.show && isDrawerOpen
                // ? "90%"
                "100%",
        }}
      >
        <div>
          <BackgroundBanner
            workspaceId={workspaceId}
            portalId={portalId}
            isPaying={isPaying}
            workspaceAlias={workspaceAlias}
            portalAlias={portalAlias}
            mode={mode}
            handleUpdateNestedTags={handleUpdateNestedTags}
          />
          {loading ? (
            <Spinner isMobileOnly={isMobileOnly} isDrawerOpen={isDrawerOpen} />
          ) : (
            <>
              {appearance.filtersType !== "none" && !isDrawerOpen && (
                <CategoryFilters
                  clearAllFilters={clearAllFilters}
                  filterTagsForUI={filterTagsForUI}
                  tagClicked={tagClicked}
                  removeTag={removeTag}
                  selectAllTopics={selectAllTopics}
                  isAllTopics={isAllTopics}
                  filtersToggleKappSelection={filtersToggleKappSelection}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedCategory={search.selectedCategory}
                  clearCategoryFilters={clearCategoryFilters}
                  selectedItems={selectedItems}
                  setUpdateNestedTags={setUpdateNestedTags}
                  handleNestedTagChange={handleNestedTagChange}
                />
              )}
              <div
                className={styles.docContainer}
                style={{ width: isDrawerOpen ? "100%" : "55%" }}
              >
                <DocumentsTable
                  documents={search.initialKeywordsDocuments.source}
                  setDocDetail={setDocDetail}
                  setDrawerOpen={setDrawerOpen}
                  totalPages={search.initialKeywordsDocuments.pages}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default KeywordLayout;
